import { trackFetchErrors } from '@atlassian/jira-errors-handling';
import { isValidationError, performPostRequest } from '@atlassian/jira-fetch';
import { mapDataToOptions } from '../../common/utils';
import type { FetchParentLinksProps } from './types';

export const fetchParentLinks = async (props: FetchParentLinksProps) => {
	const { query, autoCompleteUrl, selectedProjectId, selectedIssueTypeLabel, selectedIssueTypeId } =
		props;

	const requestPayloadWithIssueTypeName = {
		query,
		issueTypeName: selectedIssueTypeLabel,
		projectId: selectedProjectId,
		maxResults: 50,
	};

	const requestPayloadWithIssueTypeId = {
		query,
		issueTypeId: selectedIssueTypeId,
		projectId: selectedProjectId,
		maxResults: 50,
	};
	try {
		const response = await performPostRequest(autoCompleteUrl, {
			body: JSON.stringify(
				selectedIssueTypeId !== ''
					? requestPayloadWithIssueTypeId
					: requestPayloadWithIssueTypeName,
			),
		});
		return mapDataToOptions(response);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		trackFetchErrors({
			error,
			id: 'fetchParentLinks',
			packageName: 'jiraIssueFieldParentLink',
			logToSentry: !isValidationError(error),
			sendToPrivacyUnsafeSplunk: true,
		});
		throw error;
	}
};
